<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<mat-card appearance="raised" class="top-n-devices-wrapper">
    <div>
        <p class="component-label">
          <span class="draggable">{{fThreatsTitle}}</span>
          <a [routerLink]="['/history']" [queryParams]="getHeaderQueryParams()">
            <span class="mdi mdi-open-in-new open-icon link"></span>
          </a>
        </p>
        <hr>
    </div>
    <div class="icon-and-list">
        <div class="icon-area">
            <div class="mdi-stack">
              <span class="mdi mdi-monitor mdi-stack-1"></span>
              <span class="mdi mdi-bullseye-arrow mdi-stack-2"></span>
            </div>
        </div>
        <div *ngIf="topNList != null; else loadingSkeleton;" class="list-area">
          <ul>
            <li class="list-item" *ngFor="let n of topNList">
                <div class="list-info">
                    <span class="item-label">{{ n.name }}</span>
                    <span class="item-value item-color"><a attr.aria-label="{{ n.name }} {{ n.threatCount }}" class="href-link" [routerLink]="['/history']" [queryParams]="n.historyParams">{{ n.threatCount }}</a></span>
                </div>
            </li>
            <li class="list-item" *ngIf="topNList != null && topNList.length == 0">
                <span class="item-label" style="font-style: italic;">{{fThreatsNone}}</span>
            </li>
          </ul>
        </div>
        <ng-template #loadingSkeleton>
          <div style="width: 63.75%">
            <ngx-skeleton-loader
              count="5"
              appearance="line"
              [theme]="{
                  display: 'flex',
                  height: '20px',
                  width: 'inherit',
                  margin: '11px auto -5px 18px',
                }">
            </ngx-skeleton-loader>
          </div>
        </ng-template>
    </div>
</mat-card>